import { render } from "./ModalSelfScan.vue?vue&type=template&id=1ba3da38&scoped=true"
import script from "./ModalSelfScan.vue?vue&type=script&lang=js"
export * from "./ModalSelfScan.vue?vue&type=script&lang=js"

import "./ModalSelfScan.vue?vue&type=style&index=0&id=1ba3da38&scoped=true&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba3da38"]])

export default __exports__